import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import CopyToClipboard from '@cloudscape-design/components/copy-to-clipboard';

type Props = {
  /** Valor exibido (fonte monospace com fundo) e copiado ao clicar. */
  value: string;
};

/**
 * Valor copiável: renderiza em fonte fixed com fundo (`Box variant="code"`)
 * seguido do botão de copiar nativo do Cloudscape (`CopyToClipboard
 * variant="inline"`). Reutilizável para IDs, documento fiscal, endereço, etc.
 */
export function CopyValue({ value }: Props): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <CopyToClipboard
      variant="inline"
      textToCopy={value}
      textToDisplay={<Box variant="code">{value}</Box>}
      copyButtonAriaLabel={t('common.copy')}
      copySuccessText={t('common.copied')}
      copyErrorText={t('common.copyError')}
    />
  );
}
